import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../images/logo-white.png";
import whatsapp from "../images/Icons/whatsapp.png";
import { useDispatch, useSelector } from "react-redux";
import { fetchWebSetup } from "../redux/slice/webSetup";
import { useEffect } from "react";

export default function Footer() {
  const dispatch = useDispatch();
  const { webSetupData, isError } = useSelector((state) => state.webSetup);
  const [showCertificate, setShowCertificate] = useState(false);
  useEffect(() => {
    if (!isError) {
      dispatch(fetchWebSetup());
    }
  }, [dispatch, isError]);
  return (
    <>
      <footer className="footer footer-2">
        <div className="footer-middle">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-lg-5">
                <div className="widget widget-about">
                  <img
                    src={logo}
                    className="footer-logo"
                    alt="Footer Logo"
                    width="130"
                    height="25"
                  />
                  <p>{webSetupData.short_about}</p>
                </div>
              </div>
              <div className="col-sm-4 col-lg-2 col-6">
                <div className="widget">
                  <h4 className="widget-title">Customer Support</h4>
                  <ul className="widget-list">
                    <li>
                      <Link to="/contact-us">Contact us</Link>
                    </li>
                    <li>
                      <Link to="/payment-methods">Payment Methods</Link>
                    </li>
                    <li>
                      <Link to="/enquiry">Product Enquiry</Link>
                    </li>
                    <li>
                      <Link to="/historical-data">Historical Data</Link>
                    </li>
                    <li>
                      <Link to="/faq">FAQ's</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-sm-4 col-lg-2 col-6">
                <div className="widget">
                  <h4 className="widget-title">About Biznie</h4>

                  <ul className="widget-list">
                    <li>
                      <Link to="/about-us">About Us</Link>
                    </li>
                    <li>
                      <Link to="/return-policy">Return Policy</Link>
                    </li>
                    <li>
                      <Link to="/logistics">Logistics</Link>
                    </li>
                    <li>
                      <Link to="/terms-and-conditions">Terms & Conditions</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-sm-4 col-lg-3">
                <div className="widget">
                  <h4 className="widget-title">Support & Trade On Call</h4>
                  <div className="trade-call">
                    <ul className="widget-list">
                      {webSetupData.phone1 && (
                        <li>
                          <a href={`tel:+${webSetupData.phone1}`}>
                            Call us on: +91 {webSetupData.phone1}
                          </a>
                        </li>
                      )}
                      {webSetupData.phone2 && (
                        <li>
                          <a href={`tel:+${webSetupData.phone2}`}>
                            Call us on: +91 {webSetupData.phone2}
                          </a>
                        </li>
                      )}
                      {webSetupData.email && (
                        <li>
                          <a href={`mailto:${webSetupData.email}`}>
                            Write us on: {webSetupData.email}
                          </a>
                        </li>
                      )}
                    </ul>
                    {webSetupData.whatsapp && (
                      <a
                        href={`https://api.whatsapp.com/send?phone=+91${webSetupData.whatsapp}&text=Hello Biznie`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="trade-whstapp">
                          <img src={whatsapp} alt="" className="img-fluid" />
                          <div>
                            <p>Order on whatsapp</p>
                            <h6>91-{webSetupData.whatsapp}</h6>
                          </div>
                        </div>
                      </a>
                    )}

                    {/* DPIIT / Startup India */}
                    <div
                      style={{ marginTop: "16px", cursor: "pointer" }}
                      onClick={() => setShowCertificate(true)}
                      title="Click to view Startup India certificate"
                    >
                      <div
                        style={{
                          display: "inline-block",
                          background: "#fff",
                          borderRadius: "8px",
                          padding: "8px 12px",
                          marginBottom: "6px",
                        }}
                      >
                        <img
                          src="/dpiit-logo.png"
                          alt="DPIIT Recognised Startup India"
                          style={{ height: "50px", display: "block" }}
                        />
                      </div>
                      <p style={{ color: "#ccc", fontSize: "11px", margin: 0, lineHeight: "1.4" }}>
                        Recognised by Govt. of India<br />Registered with Startup India
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Certificate Modal */}
        {showCertificate && (
          <div
            onClick={() => setShowCertificate(false)}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.75)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                background: "#fff",
                borderRadius: "8px",
                padding: "16px",
                maxWidth: "90vw",
                maxHeight: "90vh",
                position: "relative",
                textAlign: "center",
              }}
            >
              <button
                onClick={() => setShowCertificate(false)}
                style={{
                  position: "absolute",
                  top: "8px",
                  right: "12px",
                  background: "none",
                  border: "none",
                  fontSize: "24px",
                  cursor: "pointer",
                  lineHeight: 1,
                }}
                aria-label="Close certificate"
              >
                &times;
              </button>
              <p style={{ fontWeight: 600, marginBottom: "12px", color: "#333" }}>
                Startup India Registration Certificate
              </p>
              <img
                src="/certificate.jpeg"
                alt="Startup India Certificate"
                style={{ maxWidth: "100%", maxHeight: "75vh", borderRadius: "4px" }}
              />
            </div>
          </div>
        )}

        <div className="footer-bottom">
          <div className="container">
            <p className="footer-copyright">
              Copyright © {new Date().getFullYear()} Biznie Tradetech LLP. All
              Rights Reserved.
            </p>
            <div className="social-icons social-icons-color">
              <span className="social-label">Follow us on</span>
              {webSetupData.facebook && (
                <a
                  href={webSetupData.facebook}
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon social-facebook"
                  title="Facebook"
                >
                  <i className="bi bi-facebook"></i>
                </a>
              )}
              {webSetupData.twitter && (
                <a
                  href={webSetupData.twitter}
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon social-twitter"
                  title="X"
                >
                  <i className="bi bi-twitter-x"></i>
                </a>
              )}
              {webSetupData.instagram && (
                <a
                  href={webSetupData.instagram}
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon social-instagram"
                  title="Instagram"
                >
                  <i className="bi bi-instagram"></i>
                </a>
              )}
              {webSetupData.youtube && (
                <a
                  href={webSetupData.youtube}
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon social-youtube"
                  title="Youtube"
                >
                  <i className="bi bi-youtube"></i>
                </a>
              )}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
